import React from 'react'

import { AiIconTip } from 'components_new/molecules/IconTip'
import { Option } from 'components_new/molecules/SelectSearch'

import type { TAttributeOptionDto } from '@homepal/api-contract'
import { TWidgetSettings } from 'types/GlobalWidget'

export const getOptions = (
  settings: TWidgetSettings,
  segmentAttributeOptions: TAttributeOptionDto[],
  aiGeneratedTitle: string
): Option[] => {
  return segmentAttributeOptions.map((option) => {
    return {
      disabled:
        option.disabled || settings.segment_by.levels.includes(option.id),
      title: option.name,
      id: option.id,
      endAdornment: option.ai_generated ? (
        <AiIconTip title={aiGeneratedTitle} />
      ) : undefined
    }
  })
}
